(function () {
  const elements = document.querySelectorAll("[data-dispatch]");
  const types = new Set();

  elements.forEach((element) => {
    const name = element.dataset.dispatch;
    const type = name.split(":").at(-1);

    types.add(type);
  });

  types.forEach((type) => {
    document.addEventListener(type, (event) => {
      const element = event.target.closest("[data-dispatch]");

      if (!element) {
        return;
      }

      if (type === "click" || type === "submit") {
        event.preventDefault();
      }

      document.dispatchEvent(new CustomEvent(element.dataset.dispatch, {
        detail: {
          target: element
        }
      }));
    });
  });
})();

class ComponentDispatch extends Theme.Component {

  connectedCallback() {
    const name = this.getAttribute("name");
    const type = name.split(":").at(-1);

    this.addEvent(type, this, (event) => {
      if (type === "click" || type === "submit") {
        event.preventDefault();
      }

      document.dispatchEvent(new CustomEvent(name, {
        detail: this.data
      }));
    });
  }
}

customElements.define("component-dispatch", ComponentDispatch);
